<template>
  <div>
    <!-- Responsive Show Small (Mobile) -->
    <vs-dropdown
      vs-trigger-click
      left
      class="cursor-pointer w3-hide-medium w3-hide-large"
    >
      <vs-button
        radius
        class="mr-2"
        color="#333f50"
        type="line"
        icon="toc"
      ></vs-button>
      <vs-dropdown-menu class="topbar-dd fontSizeData">
        <vs-dropdown-item @click="showModalComplete">
          <vs-icon icon="done" class="mr-1" id="fontIcon"></vs-icon>Approve
          Tasks
        </vs-dropdown-item>
        <vs-dropdown-item @click="showSelectModalDelete">
          <vs-icon icon="delete" class="mr-1" id="fontIcon"></vs-icon>Delete
          Tasks
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    <!-- Responsive Show Large (Web)  -->
    <vs-dropdown class="w3-hide-small btnBulk" vs-trigger-click left>
      <vs-button
        class="mr-1"
        style="color: #111111; border-radius: 20px"
        color="rgba(9, 30, 66, 0.04)"
        type="filled"
        icon="toc"
        >Bulk Actions</vs-button
      >
      <!-- <vs-button  class="mr-2"   color="dark" type="line"  icon="toc"   id="show-btn"  >Bulk Actions</vs-button> -->
      <vs-dropdown-menu class="fontSizeData">
        <vs-dropdown-item @click="showModalComplete">
          <vs-icon icon="done" class="mr-1" id="fontIcon"></vs-icon>Approve
          Tasks
        </vs-dropdown-item>
        <!-- <vs-dropdown-item   >
                <vs-icon icon="voice_over_off" class="mr-1" id="fontIcon" ></vs-icon> Inactivate
          </vs-dropdown-item> -->
        <vs-dropdown-item @click="showSelectModalDelete">
          <vs-icon icon="delete" class="mr-1" id="fontIcon"></vs-icon>Delete
          Tasks
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>

    <!-- Modal Bulk Complete Tasks -->
    <b-modal ref="my-modalCom" scrollable size="xl">
      <template #modal-title>
        <h4 style="color: #5fa74b">Bulk  Approve Tasks</h4>
      </template>
      <p class="my-4 fontSizeData">Tasks you would like to bulk complete</p>
      <vs-table :data="selectedWO">
        <template slot="thead">
          <vs-th class="fontSizeData" id="noWrap"> Work ID </vs-th>
          <vs-th class="fontSizeData" id="noWrap"> Work Order </vs-th>

          <vs-th class="fontSizeData" id="noWrap"> Name </vs-th>
          <vs-th class="fontSizeData" id="noWrap"> Email </vs-th>
          <vs-th class="fontSizeData" id="noWrap"> Start Date </vs-th>
          <vs-th class="fontSizeData" id="noWrap"> End Date </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>
            <vs-td :data="data[indextr].username">
              {{ data[indextr].username }}
            </vs-td>
            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>

            <vs-td :data="data[indextr].id">
              {{ data[indextr].plandate }}
            </vs-td>

            <vs-td :data="data[indextr].id">
              {{ data[indextr].duedate }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <bootstrap-table
        :columns="columns"
        :data="selectedWO"
        :options="options"
      ></bootstrap-table>
      <!-- <BulkCompleteTasks :data="tempdata"  /> -->
      <template #modal-footer="{}">
        <vs-button
          type="filled"
          size="sm"
          style="border-radius: 20px"
          color="success"
          @click="bulkComplete(selectedWO)"
          > Approve</vs-button
        >
        <vs-button
          class="brdbtn ml-2 mr-4"
          color="dark"
          style="width: 80px"
          type="flat"
          @click="reload()"
          >Cancel</vs-button
        >
        <!-- <b-button class="ml-2 mr-4" id="btncancel"  variant="light" @click="cancel()">
              Cancel
            </b-button> -->
      </template>
    </b-modal>

    <!-- Modal Bulk Delete Tasks -->
    <b-modal ref="my-modalDelete" size="xl" scrollable>
      <template #modal-title>
        <b class="text-danger">
          <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete
          Tasks</b
        >
      </template>
      <p class="my-4 fontSizeData">
        Are you absolutely sure you want to delete the following tasks:
      </p>
      <!-- <ul class="ml-4">
          <li class="mt-1" v-for="item in selectedWO" :key="item.name">
            {{ item.id + item.detail }}
          </li>
        </ul> -->
      <vs-table class="fontSizeData" :data="selectedWO">
        <template slot="thead">
          <vs-th class="fontSizeData" id="noWrap"> Work ID </vs-th>
          <vs-th class="fontSizeData" id="noWrap"> Work Order </vs-th>
          <vs-th class="fontSizeData" id="noWrap"> Name </vs-th>
          <vs-th class="fontSizeData" id="noWrap"> Email </vs-th>

          <vs-th class="fontSizeData" id="noWrap"> Start Date </vs-th>
          <vs-th class="fontSizeData" id="noWrap"> End Date </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td :data="data[indextr].username">
              {{ data[indextr].username }}
            </vs-td>
            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>

            <vs-td :data="data[indextr].id">
              {{ data[indextr].plandate }}
            </vs-td>

            <vs-td :data="data[indextr].id">
              {{ data[indextr].duedate }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template #modal-footer="{}">
        <!-- Button with custom close trigger value -->
        <vs-button
          class="brdbtn"
          color="dark"
          style="width: 80px"
          type="flat"
          @click="reload()"
          >Cancel</vs-button
        >
        <vs-button
          color="danger"
          style="border-radius: 20px"
          size="sm"
          @click="bulkDelete(selectedWO)"
          type="filled"
          >Delete</vs-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    selectedWO: Array,
  },
  methods: {
    reload() {
      location.reload();
    },
    showModalComplete() {
      this.$refs["my-modalCom"].show();
    },
    showSelectModalDelete() {
      this.$refs["my-modalDelete"].show();
    },
    bulkComplete(item) {
      for (let i = 0; i < item.length; i++) {
        console.log("com" + i);
        console.log(item[i]);
        const body = {
          id: item[i].id,
          username: item[i].username,
          status: "true",
        };
        this.$API
          .post("updateworkstatus", body)
          .then((result) => {
            if (result.status == 200)
              this.$vs.notify({
                title: "Work Order Updated",
                text: "Your work order has been updated",
                color: "primary",
                position: "top-center",
              });
            setTimeout(() => {
              location.reload(1);
            }, 1000);
          })
          .catch((err) => {
            if (err.response.status == 500)
              this.$vs.notify({
                title: "Invalid",
                text: "Please try again",
                color: "warning",
                position: "top-center",
              });
          });
      }

      // this.$API.post('deleteaccount', {
      //     id: item[i]
      // }).then(() => {
      //     this.$vs.notify({
      //     color:'success',
      //     title:'Deleted User',
      //     text:'The selected user was successfully deleted'
      //     })
      //     setTimeout(() => {
      //     location.reload()
      //     }, 300);
      // }).catch((err) => {

      //     this.$vs.notify({
      //     color:'danger',
      //     title:'Deleted User',
      //     text:'The selected user was failed to delete'
      //     })
      // })}
    },
    bulkDelete(item) {
      for (let i = 0; i < item.length; i++) {
        console.log(i);
        console.log(item[i].id);
        console.log(item[i].username);
        const body = {
          id: item[i].id,
          username: item[i].username,
        };
        console.log(body);
        this.$API
          .post("deletework", body)
          .then((result) => {
            if (result.status == 200)
              this.$vs.notify({
                title: "Work Order Deleted",
                text: "Your work order has been deleted",
                color: "primary",
                position: "top-center",
              });
            setTimeout(() => {
              location.reload(1);
            }, 1000);
          })
          .catch((err) => {
            if (err.response.status == 500)
              this.$vs.notify({
                title: "Invalid",
                text: "Please try again",
                color: "warning",
                position: "top-center",
              });
          });
      }
    },
  },
};
</script>

<style scoped>
.btnBulk:hover {
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.05);
  transform: translate(0, 2px);
}
.modal-open .modal {
  padding-left: 0;
}
.vs-button {
  border-radius: 20px;
}
#noWrap {
  padding: 0px;
  white-space: nowrap;
}
</style>